import { render } from "./HubsHost.vue?vue&type=template&id=bf29f3d2"
import script from "./HubsHost.vue?vue&type=script&lang=js"
export * from "./HubsHost.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__